// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(main)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(main)/_layout.tsx"); } },
  "./(main)/index.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(main)/index.tsx"); } },
  "./(main)/settings.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(main)/settings.tsx"); } },
  "./(main)/subscribe.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(main)/subscribe.tsx"); } },
  "./(workout)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(workout)/_layout.tsx"); } },
  "./(workout)/complete.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(workout)/complete.tsx"); } },
  "./(workout)/player.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(workout)/player.tsx"); } },
  "./(workout)/pre-workout.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/(workout)/pre-workout.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/_layout.tsx"); } },
  "./debug/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/debug/_layout.tsx"); } },
  "./debug/file-system.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/debug/file-system.tsx"); } },
  "./debug/index.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/debug/index.tsx"); } },
  "./debug/tv-native-events.tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/debug/tv-native-events.tsx"); } },
  "./debug/video-variations/[variation].tsx": { enumerable: true, get() { return require("/home/runner/work/fit52-tv-web/fit52-tv-web/app/debug/video-variations/[variation].tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;